module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-Kc-La.074b9cda.png";